import { apiBusSchedBaseURL, apiFilesBaseURL } from '../../authentication/Global';
import { authenticationCentral } from '../../authentication/Authentication';
import { API, HTTPMethod, ContentType } from '../APICentral';

const drawApiRoutes = {
    list: apiBusSchedBaseURL + "draw/list/",
    generateBusSched: apiBusSchedBaseURL + "draw/bussched/",
    generateLineSched: apiBusSchedBaseURL + "draw/linesched/",
    generateCarrisSched: apiBusSchedBaseURL + "draw/custom/carris/generate",
    getMissingConfigsTml: apiBusSchedBaseURL + "draw/custom/tml/missing-configs",
    regenerateTml: apiBusSchedBaseURL + "draw/custom/tml/regenerate",
    generateTmlBusSched: apiBusSchedBaseURL + "draw/custom/tml/generate/bussched",
    generateTmlStopSched: apiBusSchedBaseURL + "draw/custom/tml/generate/stopsched",
    generateSmtucLineSched: apiBusSchedBaseURL + "draw/custom/smtuc/generate/linesched",
    generateSmtucPocketSched: apiBusSchedBaseURL + "draw/custom/smtuc/generate/pocketsched",
    fixed: apiBusSchedBaseURL + "draw/fixed/",
    unfixed: apiBusSchedBaseURL + "draw/unfixed/",
    delete: apiFilesBaseURL + "files/delete/bussched/",
    deleteMultiple: apiFilesBaseURL + "files/delete/busscheds/",
    updateLinesEx: apiBusSchedBaseURL + "draw/custom/tml/updateLines",
};

export class DrawAPI {
    static generateBusSched(layout, data) {
        const url = new URL(layout, drawApiRoutes.generateBusSched);

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.POST,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(data)
        });
    }

    static generateLineSched(layout, data) {
        const url = new URL(layout, drawApiRoutes.generateLineSched);

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.POST,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(data)
        });
    }

    static generateCarrisSched(data) {
        const url = drawApiRoutes.generateCarrisSched;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.POST,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(data)
        });
    }

    static getMissingConfigsTml(filter) {
        const url = drawApiRoutes.getMissingConfigsTml;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.POST,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(filter)
        });
    }

    static regenerateTml(filter) {
        const url = drawApiRoutes.regenerateTml;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.POST,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(filter)
        });
    }

    static generateTmlBusSched(data) {
        const url = drawApiRoutes.generateTmlBusSched;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.POST,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(data)
        });
    }

    static generateTmlStopSched(data) {
        const url = drawApiRoutes.generateTmlStopSched;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.POST,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(data)
        });
    }

    static generateSmtucLineSched(data) {
        const url = drawApiRoutes.generateSmtucLineSched;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.POST,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(data)
        });
    }

    static generateSmtucPocketSched(data) {
        const url = drawApiRoutes.generateSmtucPocketSched;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.POST,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(data)
        });
    }


    static list(networkId) {
        const url = `${drawApiRoutes.list}${networkId}`;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.GET,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static fixed(fileName) {
        const url = `${drawApiRoutes.fixed}${fileName}`;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.PATCH,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static unfixed(fileName) {
        const url = `${drawApiRoutes.unfixed}${fileName}`;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.PATCH,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static delete(fileName) {
        const url = `${drawApiRoutes.delete}${fileName}`;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.DELETE,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken
        });
    }

    static deleteMultiple(filesName) {
        const url = drawApiRoutes.deleteMultiple;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.POST,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(filesName)
        });
    }

    static updateLinesEx(codes) {
        const url = drawApiRoutes.updateLinesEx;

        return API.authenticatedRequest({
            url: url,
            method: HTTPMethod.POST,
            contentType: ContentType.JSON,
            token: authenticationCentral.accessToken,
            body: JSON.stringify(codes)
        });
    }
}



// WEBPACK FOOTER //
// ./src/api/bussched/DrawAPI.js